import { useState, useEffect, RefObject } from 'react';
import { isNull, isUndefined } from 'underscore';

export default function useLazyScroll (container: RefObject<any>) {
  const [scrollEnd, setScroll] = useState(false);
  const { height } = (container && container.current) ? container.current.getBoundingClientRect() : { height: 0 };

  const clientHeight = (container.current && container.current.clientHeight) || null;
  const scrollHeight = (container.current && container.current.scrollHeight) || null; 
  const screenIsBiggerThanList = scrollHeight <= clientHeight;

  useEffect(() => {
    const checkScroll = ({ target }: {target: Element}) => {
      const scrollTop = Math.round(target.scrollTop);
      const scrollHeightNew = Math.round(target.scrollHeight);
      const clientHeightNew = Math.round(target.clientHeight);
      const scrollDiff = scrollTop + clientHeightNew;
      const scrollEndNew = scrollDiff >= scrollHeightNew;
 
      if(scrollEnd !== scrollEndNew){
        setScroll(scrollEndNew);
      }
    };

    const currentContainer = container?.current;
    currentContainer?.addEventListener('scroll', checkScroll);
    return () => {
      currentContainer?.removeEventListener('scroll', checkScroll);
    };
  },
  //eslint-disable-next-line react-hooks/exhaustive-deps
  [scrollEnd, height, container.current]
  );

  return (scrollEnd || screenIsBiggerThanList) && (!isUndefined(container.current) && !isNull(container.current));
}
